var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuy4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25H84C86.2091 25 88 26.7909 88 29V72C88 74.2091 86.2091 76 84 76H16C13.7909 76 12 74.2091 12 72V29C12 26.7909 13.7909 25 16 25ZM8 29C8 24.5817 11.5817 21 16 21H84C88.4183 21 92 24.5817 92 29V72C92 76.4183 88.4183 80 84 80H16C11.5817 80 8 76.4183 8 72V29ZM23 63C21.6193 63 20.5 64.1193 20.5 65.5C20.5 66.8807 21.6193 68 23 68H71C72.3807 68 73.5 66.8807 73.5 65.5C73.5 64.1193 72.3807 63 71 63H23ZM20.5 55C20.5 53.6193 21.6193 52.5 23 52.5H71C72.3807 52.5 73.5 53.6193 73.5 55C73.5 56.3807 72.3807 57.5 71 57.5H23C21.6193 57.5 20.5 56.3807 20.5 55ZM26.0938 45.1875C29.4592 45.1875 32.1875 42.4592 32.1875 39.0938C32.1875 35.7283 29.4592 33 26.0938 33C22.7283 33 20 35.7283 20 39.0938C20 42.4592 22.7283 45.1875 26.0938 45.1875Z",
    fill: "url(#paint0_linear_102_1245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1245",
    x1: 8,
    y1: 21,
    x2: 62.6139,
    y2: 97.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy4);
export default __webpack_public_path__ + "static/media/buy4.d62249b23dba02be6adcebb9ffc13bde.svg";
export { ForwardRef as ReactComponent };